<template>
<div>
    <div class='item-actions icon-text-buttons flex-container'>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendDataUpdated('displaylayout')" v-if="$UIPrivilege('devices/ssedisplays', 'send.layout')">
            <b-icon icon="columns"/>
            <span>{{ $t('sse_displays.actionBtn.layout') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendDataUpdated('timetables')" v-if="$UIPrivilege('devices/ssedisplays', 'send.timetables')">
            <b-icon icon="justify"/>
            <span>{{ $t('sse_displays.actionBtn.timetables') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendDataUpdated('announcements')" v-if="$UIPrivilege('devices/ssedisplays', 'send.info')">
            <b-icon icon="info-square"/>
            <span>{{ $t('sse_displays.actionBtn.infos') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendDisplayRestart()" v-if="$UIPrivilege('devices/ssedisplays', 'send.reboot')">
            <b-icon icon="bootstrap-reboot"/>
           <span>{{ $t('sse_displays.actionBtn.restart') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendDataUpdated('displayconfiguration')" v-if="$UIPrivilege('devices/ssedisplays', 'send.conf')">
            <b-icon icon="gear"/>
           <span>{{ $t('sse_displays.actionBtn.configuration') }}</span>
        </p-button>
    </div>
    <RequestInfo :ok="ok" :error="error" :loader="loading" />
</div>
</template>

<script>

export default {
    props: ['item'], 
    data() {
        return {
            ok: false,
            error: false,
            loading: false
        }
    },
    computed: {
        display() {
            return this.item;
        }
    },
    watch: {
       display(){
            this.ok = this.error = this.loading = false;
       } 
    },
    methods: {
        sendDataUpdated(action) {
            this.ok = this.error = false;
            this.loading = true;
            const self = this;
            this.$traveller_http.get('/traveller/restui/ssedisplay/sendDataUpdated', { params: { "deviceid": this.display.deviceId, "dataupdated": action } })
            .then(() => {
                setTimeout(() => { self.ok = true; self.loading = false; }, 1000);               
            })
            .catch(() => {
                 setTimeout(() => { self.error = true; self.loading = false;}, 1000);          
            })
            .finally();
        },
        sendDisplayRestart() {
            this.ok = this.error = false;
            this.loading = true;
            const self = this;
            this.$traveller_http.post('/traveller/restui/ssedisplay/sendrestartrequests', [ this.display.deviceId ])
            .then(() => {
                setTimeout(() => { self.ok = true; self.loading = false; }, 1000);               
            })
            .catch(() => {
                 setTimeout(() => { self.error = true; self.loading = false;}, 1000);          
            })
            .finally();
        }
    }
}

</script>

<style scoped lang="scss" >

        .flex-container {
            display: flex;
            flex-direction: column;
            align-items: center;


            .flex-child {
                flex: 1;
                width: 200px;
            }
        }

</style>